<template>
<PrimevueCard  class="w-full mt-2" >
    <template #title>
      <div class="font-medium text-xl">
            Všetky prílohy podľa typu
      </div>
    </template>
    <template #content>
      <Fieldset v-for="attType in this.attTypes" v-bind:key="attType.id" :legend="attType.name" toggleable collapsed>
        <AttachmentList  :internal="true"  :messageId="this.$props.orderId" :attTypeId="attType.id"></AttachmentList>
        <AttachmentList v-if="store.user.department.id != 1" :internal="false" :messageId="this.$props.orderId" :attTypeId="attType.id"></AttachmentList>        
      </Fieldset>
    </template>

</PrimevueCard>


</template>

<script lang="ts">
import Security from './security'
import {store} from './store'
import PrimevueCard from 'primevue/card';
import AttachmentList from '@/components/AttachmentList.vue';
import notie from "notie/dist/notie";
import {emiter} from '../main';
import Fieldset from 'primevue/fieldset';


export default {
    name: 'AttachmentsByType',
    components: {
      AttachmentList,
      PrimevueCard,
      Fieldset,
    },
    props: [
       //"internal",
       "orderId",
       
       ],
    data() {
        return {
            store,
            attTypes : [],
        }
    },
 
    beforeMount() {

      if(Security.requireToken()){
        store.selectModul = this.$route.path.split("/")[1]
        this.loadData();
        emiter.on('reloadAttByType',this.loadData)
      }
    },
    
    methods: {
      loadData(){

        let condition = "?internal=false"
        if(store.user.department.id == 1){
          condition = "?internal=true"
        }
      
        fetch(store.Api_url + "/att-types/" + this.$props.orderId+condition , Security.requestOptions("GET"))
              .then((response) => response.json())
              .then((responseData) => {
                if (responseData.error) {
                  //console.log("error:", responseData.message);
                  notie.alert({
                    type: 'error',
                    text: 'Nepodarilo sa načítať zoznam typov príloh',
                    position: "bottom"
                  })          
                } else {
                  
                  if(responseData.data != null){
                    this.attTypes = responseData.data;

                  } else{

                    this.attTypes = []

                  }
    
  
                }
        });
      }
    },


    beforeUnmount(){
      emiter.off('reloadAttByType',this.loadData);
    },  
}    
</script>